export const ADD_TO_SLACK_URL = `https://slack.com/oauth/v2/authorize?scope=commands,channels:history,channels:read,channels:join,users:read,users:read.email,groups:history,groups:read,groups:write,im:read,mpim:read,chat:write,chat:write.customize,pins:read,pins:write,usergroups:read&user_scope=channels:read,groups:history,groups:read,groups:write,channels:history,users:read,chat:write,reactions:read,reactions:write,usergroups:read&client_id=1138351380305.1599854316209&redirect_uri=${process.env["REACT_APP_URI"]}`;
export const NOTION_URL = `https://api.notion.com/v1/oauth/authorize?client_id=${process.env["REACT_APP_NOTION_CLIENT_ID"]}&response_type=code&redirect_uri=${process.env["REACT_APP_URI"]}`;
export const GITHUB_URL = `https://github.com/apps/dots-for-communities/installations/new`;

export const TAG_COLORS = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
  "#2db7f5",
  "#87d068",
  "#108ee9",
];

export const LOGIN_SLACK_URL = `https://slack.com/oauth/v2/authorize?user_scope=identity.basic,identity.email,identity.team,identity.avatar&client_id=1138351380305.1599854316209&redirect_uri=${process.env["REACT_APP_URI"]}/auth/signedin/`;

const discordPermissions = "395574496338"; // see notion doc on permissions and ticket for more info: https://app.shortcut.com/sedimentiq/story/1616/change-the-auth-permission-code#activity-1728
export const DISCORD_OAUTH_URL = `https://discord.com/api/oauth2/authorize?client_id=${process.env["REACT_APP_DISCORD_CLIENT_ID"]}&permissions=${discordPermissions}&response_type=code`;

export function createDiscordUrl(
  type: "add-bot" | "oauth" | "discord-tokens",
  guildId?: string
) {
  let scopes, redirectUrl, permissions;
  switch (type) {
    case "add-bot":
      scopes = ["bot", "identify", "email", "applications.commands"]; //TODO what other scopes do we need here?
      redirectUrl = `${process.env["REACT_APP_URI"]}/onboarding/discord/bot-added/`;
      permissions = discordPermissions;
      break;
    case "discord-tokens":
      scopes = ["identify", "guilds", "email"];
      redirectUrl = `${process.env["REACT_APP_URI"]}/settings/`;
      break;
    default:
      scopes = ["identify", "guilds", "email"];
      redirectUrl = `${process.env["REACT_APP_URI"]}/onboarding/discord/`;
      break;
  }
  return `${DISCORD_OAUTH_URL}&redirect_uri=${encodeURIComponent(
    redirectUrl
  )}&scope=${encodeURIComponent(scopes.join(" "))}${
    guildId ? `&guild_id=${guildId}` : ""
  }${permissions ? `&permissions=${permissions}` : ""}`;
}
